export const BACKGROUND_TEXTURE_SIZE = 1000;

const BACKGROUND_LAYERS = ['BG', 'MG', 'FG'];

export const getBackgroundAsset = (backgroundName, layer) => {
	const src = `assets/images/backgrounds/${backgroundName}${layer}.svg`;

	return {
		alias: src,
		src,
		data: {
			width: BACKGROUND_TEXTURE_SIZE,
			height: BACKGROUND_TEXTURE_SIZE,
		},
	};
};

export const loadBackgroundTextures = (assets, backgroundName) => Promise.all(
	BACKGROUND_LAYERS.map(layer => assets.load(getBackgroundAsset(backgroundName, layer)))
);
